import {
  Divider,
  Field as ObjectclassField,
  Text,
  TextFading,
  YesObject
} from '@yes.technology/react-toolkit'

import {
  Field,
  ValueContainer
} from 'component/TaskObjectCard/TaskObjectCard.styles'
import formatTaskCardFieldValue from '../helpers/formatTaskCardFieldValue'

type TaskCardFieldSlideProps = {
  fieldKey: string
  field?: ObjectclassField
  value?: YesObject[keyof YesObject] | null
  language: string
}

const TaskCardFieldSlide = ({
  fieldKey,
  field,
  value,
  language
}: TaskCardFieldSlideProps) => {
  const label = field?.display_text?.des ?? fieldKey
  const formattedValue = formatTaskCardFieldValue({
    value,
    field,
    language
  })

  return (
    <Field style={{ width: '100%', minWidth: 0 }}>
      <TextFading>
        <Text variant='content-emphasis-02'>{label}</Text>
      </TextFading>
      <Divider heightClass='small' color='gray' />
      <ValueContainer>
        <TextFading>{formattedValue}</TextFading>
      </ValueContainer>
    </Field>
  )
}

export default TaskCardFieldSlide
